module.exports = __webpack_public_path__ + "img/schedule.5ef51a59.png";